import { defineAsyncComponent as e } from "vue";
//#endregion
//#region src/lang/index.ts
var t = {
	en: {
		general: { notVisible: "Not visible" },
		components: {
			ruleRemoveTitle: "Change configuration",
			ruleRemoveDescription: "Are you sure you want to change this configuration?",
			selectAllTeams: "Select all",
			unselectAllTeams: "Deselect all"
		},
		selectors: { dataProvider: "Data provider" },
		sportLive: { blocks: {
			appearanceBeforeLiveEvent: "Visibility before start of match (hours)",
			appearanceAfterLiveEvent: "Visibility after end of match (hours)",
			headlinePrimary: "Title (primary)",
			headlinePrimaryHint: "Shown in default text colour",
			headlineAccent: "Title (accent)",
			headlineAccentHint: "Shown in accent colour (optional)",
			headlinePreview: "Preview with Vibe accent",
			showHeadline: "Show title",
			widgetDisabled: "Do not show widget",
			channelSportHeuteWidgetBlock: "Sport-Heute widget",
			ruleLabels: {
				SORT_BY_COUNTRY_RULE: "By Country",
				SORT_BY_COMPETITION_RULE: "By Competition",
				SORT_BY_EVENT_STATUS_RULE: "By match status",
				SORT_BY_TEAM_POPULARITY_RULE: "By team",
				SORT_BY_EVENT_SCHEDULED_TIME: "By event scheduled time"
			},
			filtersLabels: { FILTER_BY_COMPETITION_TEAMS: "By competition and teams" },
			statusLabels: {
				ongoing: "Ongoing",
				upcoming: "Upcoming",
				ended: "Ended"
			},
			eventScheduledTime: "Event scheduled time",
			rulesSection: "Rules",
			visibilityRulesSection: "Visibility",
			sortingRulesSection: "Sorting",
			infoPosition: "When placed in position 1, the sport widget in the FOL app is automatically moved to position 2 (position 1 = news appetizer).",
			validation: { headlinePrimaryRequired: "The primary title is required when the title is shown." }
		} },
		countries: {
			AFG: "Afghanistan",
			ALB: "Albania",
			ALG: "Algeria",
			AND: "Andorra",
			ANG: "Angola",
			ATG: "Antigua and Barbuda (FIFA)",
			ANT: "Antigua and Barbuda",
			ARG: "Argentina",
			ARM: "Armenia",
			ARU: "Aruba",
			ASA: "American Samoa",
			AUS: "Australia",
			AUT: "Austria",
			AZE: "Azerbaijan",
			BAH: "Bahamas",
			BAN: "Bangladesh",
			BRB: "Barbados (FIFA)",
			BAR: "Barbados",
			BDI: "Burundi",
			BEL: "Belgium",
			BEN: "Benin",
			BER: "Bermuda",
			BHU: "Bhutan",
			BIH: "Bosnia and Herzegovina",
			BLZ: "Belize (FIFA)",
			BIZ: "Belize",
			BLR: "Belarus",
			BOL: "Bolivia",
			BOT: "Botswana",
			BRA: "Brazil",
			BHR: "Bahrain (FIFA)",
			BRN: "Bahrain",
			BRU: "Brunei",
			BUL: "Bulgaria",
			BFA: "Burkina Faso (FIFA)",
			BUR: "Burkina Faso",
			CTA: "Central African Republic (FIFA)",
			CAF: "Central African Republic",
			CAM: "Cambodia",
			CAN: "Canada",
			CAY: "Cayman Islands",
			CGO: "Republic of the Congo",
			CHA: "Chad",
			CHI: "Chile",
			CHN: "People's Republic of China",
			CIV: "Ivory Coast",
			CMR: "Cameroon",
			COD: "Democratic Republic of the Congo",
			COR: "South Korea",
			COK: "Cook Islands",
			COL: "Colombia",
			COM: "Comoros",
			CPV: "Cape Verde",
			CRC: "Costa Rica",
			CRO: "Croatia",
			CUB: "Cuba",
			CYP: "Cyprus",
			CZE: "Czechia",
			DEN: "Denmark",
			DJI: "Djibouti",
			DMA: "Dominica",
			DOM: "Dominican Republic",
			ECU: "Ecuador",
			EGY: "Egypt",
			ERI: "Eritrea",
			SLV: "El Salvador (FIFA)",
			ESA: "El Salvador",
			ESP: "Spain",
			EST: "Estonia",
			ETH: "Ethiopia",
			FIJ: "Fiji",
			FIN: "Finland",
			FRA: "France",
			FSM: "Federated States of Micronesia",
			GAB: "Gabon",
			GAM: "The Gambia",
			GBR: "Great Britain",
			GNB: "Guinea-Bissau (FIFA)",
			GBS: "Guinea-Bissau",
			GEO: "Georgia",
			EQG: "Equatorial Guinea (FIFA)",
			GEQ: "Equatorial Guinea",
			GER: "Germany",
			GHA: "Ghana",
			GRE: "Greece",
			GRN: "Grenada",
			GUA: "Guatemala",
			GUI: "Guinea",
			GUM: "Guam",
			GUY: "Guyana",
			HAI: "Haiti",
			HKG: "Hong Kong",
			HON: "Honduras",
			HUN: "Hungary",
			IDN: "Indonesia (FIFA)",
			INA: "Indonesia",
			IND: "India",
			IRN: "Iran (FIFA)",
			IRI: "Iran",
			IRL: "Ireland",
			IRQ: "Iraq",
			ISL: "Iceland",
			ISR: "Israel",
			VIR: "Virgin Islands (FIFA)",
			ISV: "Virgin Islands",
			ITA: "Italy",
			VGB: "British Virgin Islands (FIFA)",
			IVB: "British Virgin Islands",
			JAM: "Jamaica",
			JOR: "Jordan",
			JPN: "Japan",
			KAZ: "Kazakhstan",
			KEN: "Kenya",
			KGZ: "Kyrgyzstan",
			KIR: "Kiribati",
			KOR: "South Korea",
			KVX: "Kosovo (FIFA)",
			KOS: "Kosovo",
			KSA: "Saudi Arabia",
			KUW: "Kuwait",
			LAO: "Laos",
			LVA: "Latvia (FIFA)",
			LAT: "Latvia",
			LBY: "Libya (FIFA)",
			LBA: "Libya",
			LBN: "Lebanon",
			LBR: "Liberia",
			LCA: "Saint Lucia",
			LES: "Lesotho",
			LIE: "Liechtenstein",
			LTU: "Lithuania",
			LUX: "Luxembourg",
			MAD: "Madagascar",
			MAR: "Morocco",
			MAS: "Malaysia",
			MWI: "Malawi (FIFA)",
			MAW: "Malawi",
			MDA: "Moldova",
			MDV: "Maldives",
			MEX: "Mexico",
			MGL: "Mongolia",
			MHL: "Marshall Islands",
			MKD: "North Macedonia",
			MLI: "Mali",
			MLT: "Malta",
			MNE: "Montenegro",
			MON: "Monaco",
			MOZ: "Mozambique",
			MRI: "Mauritius",
			MTN: "Mauritania",
			MYA: "Myanmar",
			NAM: "Namibia",
			NCA: "Nicaragua",
			NED: "Netherlands",
			NEP: "Nepal",
			NGA: "Nigeria (FIFA)",
			NGR: "Nigeria",
			NIG: "Niger",
			NOR: "Norway",
			NRU: "Nauru",
			NZL: "New Zealand",
			OMA: "Oman",
			PAK: "Pakistan",
			PAN: "Panama",
			PAR: "Paraguay",
			PER: "Peru",
			PHI: "Philippines",
			PAL: "Palestine (FIFA)",
			PLE: "Palestine",
			PLW: "Palau",
			PNG: "Papua New Guinea",
			POL: "Poland",
			POR: "Portugal",
			PRK: "North Korea",
			PUR: "Puerto Rico",
			QAT: "Qatar",
			ROC: "Republic of China",
			ROU: "Romania",
			RSA: "South Africa",
			RUS: "Russia",
			RWA: "Rwanda",
			SAM: "Samoa",
			SEN: "Senegal",
			SEY: "Seychelles",
			SGP: "Singapore",
			SKN: "Saint Kitts and Nevis",
			SLE: "Sierra Leone",
			SVN: "Slovenia (FIFA)",
			SLO: "Slovenia",
			SMR: "San Marino",
			SOL: "Solomon Islands",
			SOM: "Somalia",
			SRB: "Serbia",
			SRI: "Sri Lanka",
			SSD: "South Sudan",
			STP: "São Tomé and Príncipe",
			SDN: "Sudan (FIFA)",
			SUD: "Sudan",
			SUI: "Switzerland",
			SUR: "Suriname",
			SVK: "Slovakia",
			SWE: "Sweden",
			SWZ: "Eswatini",
			SYR: "Syria",
			TAN: "Tanzania",
			TGA: "Tonga",
			THA: "Thailand",
			TJK: "Tajikistan",
			TKM: "Turkmenistan",
			TLS: "Timor-Leste",
			TOG: "Togo",
			TPE: "Republic of China",
			TTO: "Trinidad and Tobago",
			TUN: "Tunisia",
			TUR: "Turkey",
			TUV: "Tuvalu",
			UAE: "United Arab Emirates",
			UGA: "Uganda",
			UKR: "Ukraine",
			URU: "Uruguay",
			USA: "United States",
			UZB: "Uzbekistan",
			VAN: "Vanuatu",
			VEN: "Venezuela",
			VIE: "Vietnam",
			VIN: "Saint Vincent and the Grenadines",
			YEM: "Yemen",
			ZAM: "Zambia",
			ZIM: "Zimbabwe",
			MAC: "Macau",
			ENG: "England",
			FRO: "Faroe Islands",
			GIB: "Gibraltar",
			NIR: "Northern Ireland",
			SCO: "Scotland",
			WAL: "Wales",
			CUW: "Curaçao",
			MSR: "Montserrat",
			TCA: "Turks and Caicos Islands",
			NCL: "New Caledonia",
			TAH: "Tahiti"
		}
	},
	de: {
		general: { notVisible: "Nicht sichtbar" },
		components: {
			ruleRemoveTitle: "Konfiguration ändern",
			ruleRemoveDescription: "Willst du diese Konfiguration wirklich ändern?",
			selectAllTeams: "Alle auswählen",
			unselectAllTeams: "Alle abwählen"
		},
		selectors: { dataProvider: "Anbieter" },
		sportLive: { blocks: {
			appearanceBeforeLiveEvent: "Sichtbarkeit vor Beginn des Spiels (Stunden)",
			appearanceAfterLiveEvent: "Sichtbarkeit nach Ende des Spiels (Stunden)",
			headlinePrimary: "Titel (primär)",
			headlinePrimaryHint: "Wird in der Standard-Textfarbe angezeigt",
			headlineAccent: "Titel (Akzent)",
			headlineAccentHint: "Wird in der Akzentfarbe angezeigt (optional)",
			headlinePreview: "Vorschau mit Vibe-Akzent",
			showHeadline: "Titel anzeigen",
			widgetDisabled: "Nicht anzeigen",
			channelSportHeuteWidgetBlock: "Sport-Heute-Widget",
			ruleLabels: {
				SORT_BY_COUNTRY_RULE: "Nach Land",
				SORT_BY_COMPETITION_RULE: "Nach Turnier",
				SORT_BY_EVENT_STATUS_RULE: "Nach Spiel-Status",
				SORT_BY_TEAM_POPULARITY_RULE: "Nach Mannschaft",
				SORT_BY_EVENT_SCHEDULED_TIME: "Nach der geplanten Veranstaltungszeit"
			},
			filtersLabels: { FILTER_BY_COMPETITION_TEAMS: "Nach Turnieren und Teams" },
			statusLabels: {
				ongoing: "Läuft",
				upcoming: "Bevorstehend",
				ended: "Beendet"
			},
			eventScheduledTime: "Geplante Veranstaltungszeit",
			rulesSection: "Regeln",
			visibilityRulesSection: "Sichtbarkeit",
			sortingRulesSection: "Sortierung",
			infoPosition: "Bei Platzierung auf Position 1 wird das Sport-Widget in der FOL-App automatisch auf Position 2 verschoben (Position 1 = News-Appetizer).",
			validation: { headlinePrimaryRequired: "Der primäre Titel ist erforderlich, wenn der Titel angezeigt wird." }
		} },
		countries: {
			AFG: "Afghanistan",
			ALB: "Albanien",
			ALG: "Algerien",
			AND: "Andorra",
			ANG: "Angola",
			ATG: "Antigua und Barbuda (FIFA)",
			ANT: "Antigua und Barbuda",
			ARG: "Argentinien",
			ARM: "Armenien",
			ARU: "Aruba",
			ASA: "Amerikanisch-Samoa",
			AUS: "Australien",
			AUT: "Österreich",
			AZE: "Aserbaidschan",
			BAH: "Bahamas",
			BAN: "Bangladesch",
			BRB: "Barbados (FIFA)",
			BAR: "Barbados",
			BDI: "Burundi",
			BEL: "Belgien",
			BEN: "Benin",
			BER: "Bermuda",
			BHU: "Bhutan",
			BIH: "Bosnien und Herzegowina",
			BLZ: "Belize (FIFA)",
			BIZ: "Belize",
			BLR: "Belarus",
			BOL: "Bolivien",
			BOT: "Botswana",
			BRA: "Brasilien",
			BHR: "Bahrain (FIFA)",
			BRN: "Bahrain",
			BRU: "Brunei",
			BUL: "Bulgarien",
			BFA: "Burkina Faso (FIFA)",
			BUR: "Burkina Faso",
			CTA: "Zentralafrikanische Republik (FIFA)",
			CAF: "Zentralafrikanische Republik",
			CAM: "Kambodscha",
			CAN: "Kanada",
			CAY: "Cayman Islands",
			CGO: "Republik Kongo",
			CHA: "Tschad",
			CHI: "Chile",
			CHN: "Volksrepublik China",
			CIV: "Côte d’Ivoire",
			CMR: "Kamerun",
			COD: "Demokratische Republik Kongo",
			COK: "Cookinseln",
			COL: "Kolumbien",
			COM: "Komoren",
			COR: "Korea",
			CPV: "Kap Verde",
			CRC: "Costa Rica",
			CRO: "Kroatien",
			CUB: "Kuba",
			CYP: "Zypern",
			CZE: "Tschechien",
			DEN: "Dänemark",
			DJI: "Dschibuti",
			DMA: "Dominica",
			DOM: "Dominikanische Republik",
			ECU: "Ecuador",
			EGY: "Ägypten",
			ERI: "Eritrea",
			SLV: "El Salvador (FIFA)",
			ESA: "El Salvador",
			ESP: "Spanien",
			EST: "Estland",
			ETH: "Äthiopien",
			FIJ: "Fidschi",
			FIN: "Finnland",
			FRA: "Frankreich",
			FSM: "Föderierte Staaten von Mikronesien",
			GAB: "Gabun",
			GAM: "Gambia",
			GBR: "Großbritannien und Nordirland",
			GNB: "Guinea-Bissau (FIFA)",
			GBS: "Guinea-Bissau",
			GEO: "Georgien",
			EQG: "Äquatorialguinea (FIFA)",
			GEQ: "Äquatorialguinea",
			GER: "Deutschland",
			GHA: "Ghana",
			GRE: "Griechenland",
			GRN: "Grenada",
			GUA: "Guatemala",
			GUI: "Guinea",
			GUM: "Guam",
			GUY: "Guyana",
			HAI: "Haiti",
			HKG: "Hongkong",
			HON: "Honduras",
			HUN: "Ungarn",
			IDN: "Indonesien (FIFA)",
			INA: "Indonesien",
			IND: "Indien",
			IRN: "Iran (FIFA)",
			IRI: "Iran",
			IRL: "Irland",
			IRQ: "Irak",
			ISL: "Island",
			ISR: "Israel",
			VIR: "Amerikanische Jungferninseln (FIFA)",
			ISV: "Amerikanische Jungferninseln",
			ITA: "Italien",
			VGB: "Britische Jungferninseln (FIFA)",
			IVB: "Britische Jungferninseln",
			JAM: "Jamaika",
			JOR: "Jordanien",
			JPN: "Japan",
			KAZ: "Kasachstan",
			KEN: "Kenia",
			KGZ: "Kirgisistan",
			KIR: "Kiribati",
			KOR: "Republik Korea",
			KVX: "Kosovo (FIFA)",
			KOS: "Kosovo",
			KSA: "Saudi-Arabien",
			KUW: "Kuwait",
			LAO: "Laos",
			LVA: "Lettland (FIFA)",
			LAT: "Lettland",
			LBY: "Libyen (FIFA)",
			LBA: "Libyen",
			LBN: "Libanon",
			LBR: "Liberia",
			LCA: "St. Lucia",
			LES: "Lesotho",
			LIE: "Liechtenstein",
			LTU: "Litauen",
			LUX: "Luxemburg",
			MAD: "Madagaskar",
			MAR: "Marokko",
			MAS: "Malaysia",
			MWI: "Malawi (FIFA)",
			MAW: "Malawi",
			MDA: "Moldau",
			MDV: "Malediven",
			MEX: "Mexiko",
			MGL: "Mongolei",
			MHL: "Marshallinseln",
			MKD: "Nordmazedonien",
			MLI: "Mali",
			MLT: "Malta",
			MNE: "Montenegro",
			MON: "Monaco",
			MOZ: "Mosambik",
			MRI: "Mauritius",
			MTN: "Mauretanien",
			MYA: "Myanmar",
			NAM: "Namibia",
			NCA: "Nicaragua",
			NED: "Niederlande",
			NEP: "Nepal",
			NGA: "Nigeria (FIFA)",
			NGR: "Nigeria",
			NIG: "Niger",
			NOR: "Norwegen",
			NRU: "Nauru",
			NZL: "Neuseeland",
			OMA: "Oman",
			PAK: "Pakistan",
			PAN: "Panama",
			PAR: "Paraguay",
			PER: "Peru",
			PHI: "Philippinen",
			PAL: "Palästina (FIFA)",
			PLE: "Palästina",
			PLW: "Palau",
			PNG: "Papua-Neuguinea",
			POL: "Polen",
			POR: "Portugal",
			PRK: "DVR Korea",
			PUR: "Puerto Rico",
			QAT: "Katar",
			ROC: "Republik China",
			ROU: "Rumänien",
			RSA: "Südafrika",
			RUS: "Russische Föderation",
			RWA: "Ruanda",
			SAM: "Samoa",
			SEN: "Senegal",
			SEY: "Seychellen",
			SGP: "Singapur",
			SKN: "St. Kitts und Nevis",
			SLE: "Sierra Leone",
			SVN: "Slowenien (FIFA)",
			SLO: "Slowenien",
			SMR: "San Marino",
			SOL: "Salomonen",
			SOM: "Somalia",
			SRB: "Serbien",
			SRI: "Sri Lanka",
			SSD: "Südsudan",
			STP: "São Tomé und Príncipe",
			SDN: "Sudan (FIFA)",
			SUD: "Sudan",
			SUI: "Schweiz",
			SUR: "Suriname",
			SVK: "Slowakei",
			SWE: "Schweden",
			SWZ: "Eswatini",
			SYR: "Syrien",
			TAN: "Tansania",
			TGA: "Tonga",
			THA: "Thailand",
			TJK: "Tadschikistan",
			TKM: "Turkmenistan",
			TLS: "Osttimor",
			TOG: "Togo",
			TPE: "Chinesisch Taipeh",
			TTO: "Trinidad und Tobago",
			TUN: "Tunesien",
			TUR: "Türkei",
			TUV: "Tuvalu",
			UAE: "Vereinigte Arabische Emirate",
			UGA: "Uganda",
			UKR: "Ukraine",
			URU: "Uruguay",
			USA: "USA",
			UZB: "Usbekistan",
			VAN: "Vanuatu",
			VEN: "Venezuela",
			VIE: "Sozialistische Republik Vietnam",
			VIN: "St. Vincent und die Grenadinen",
			YEM: "Jemen",
			ZAM: "Sambia",
			ZIM: "Simbabwe",
			MAC: "Macau",
			ENG: "England",
			FRO: "Färöer",
			GIB: "Gibraltar",
			NIR: "Nordirland",
			SCO: "Schottland",
			WAL: "Wales",
			CUW: "Curaçao",
			MSR: "Montserrat",
			TCA: "Turks- und Caicosinseln",
			NCL: "Neukaledonien",
			TAH: "Tahiti"
		}
	}
}, n = e(() => import("./sport-heute-channel-block-COtLwmBk.js")), r = {
	messages: t,
	routes: []
};
//#endregion
export { n as ChannelSportHeuteWidgetBlock, r as sportHeuteWidget };

//# sourceMappingURL=index.es.js.map